import megaNav from './header/megaMenu';
var processInclude = require('base/util');

export default {
    init: () => {
        processInclude(megaNav);
    }
};